export default {
  // Header
  header: {
    home: 'Inicio',
    about: 'Acerca',
    services: 'Servicios',
    contact: 'Contacto'
  },

  // Aviso de Shabat
  shabbat: {
    notice: 'Estamos en observancia del Shabat. Volveremos después de la puesta del sol del sábado.'
  },

  // Hero Section
  hero: {
    title: 'Transformamos Ideas en',
    titleHighlight: 'Soluciones Digitales',
    subtitle: 'Desarrollo personalizado, consultoría técnica y soporte especializado',
    ctaClients: 'Conoce Nuestros Clientes',
    ctaContact: 'Habla Con Nosotros',
    mysteryQuote: 'Algo extraordinario se está gestando en el reino digital...',
    description: 'Donde la inteligencia artificial se encuentra con el ingenio humano, donde la automatización trasciende fronteras, y donde el futuro de la tecnología se despliega ante tus ojos.',
    comingSoon: 'Próximamente',
    mysteryText: 'La revolución comienza...',
    joinFuture: 'Unite al Futuro',
    stats: {
      experience: 'Años de Experiencia',
      innovation: 'Innovación',
      powered: 'Potenciado'
    }
  },
  
  // Clients Section
  clients: {
    title: 'Clientes',
    subtitle: 'Conoce algunos de nuestros clientes'
  },

  // Features Section
  features: {
    title: 'Nuestros Servicios',
    subtitle: 'Nuestros servicios especializados para impulsar tu transformación digital',
    badge: 'Especialidad',
    development: {
      title: 'Desarrollo Personalizado',
      description: 'Creación de soluciones a medida que satisfacen las necesidades específicas de cada cliente, utilizando las mejores prácticas de ingeniería de software, diseño responsivo y tecnologías modernas.'
    },
    consulting: {
      title: 'Consultoría Técnica',
      description: 'Planificación, diseño e implementación de arquitecturas robustas, garantizando alta disponibilidad, seguridad y rendimiento para tu infraestructura o aplicación.'
    },
    support: {
      title: 'Soporte Técnico',
      description: 'Atención especializada para resolución de problemas en servidores, redes, sistemas y entornos corporativos. Actuamos de forma proactiva para mantener tus servicios siempre disponibles y seguros.'
    }
  },
  
  // Contact Section
  contact: {
    title: 'Contacto',
    email: 'Email',
    phone: 'Teléfono',
    schedule: 'Horario',
    scheduleText: 'Lunes a Jueves: 08:00 - 18:00',
    scheduleTime: 'Viernes: 08:00 - 14:00',
    prepareTitle: 'Preparate',
    titleHighlight: 'para el Futuro',
    subtitle: 'Sé uno de los primeros en experimentar la próxima generación de soluciones tecnológicas. Unite a nuestra lista de espera exclusiva y mantente actualizado sobre nuestro lanzamiento revolucionario.',
    
    // Why Choose Z3C
    whyChoose: {
      title: '¿Por qué Elegir Z3C?',
      experience: '20+ años de experiencia combinada en desarrollo de software',
      ai: 'Experiencia de vanguardia en IA y machine learning',
      automation: 'Historial comprobado en automatización y optimización',
      security: 'Seguridad y cumplimiento de nivel empresarial',
      cloud: 'Soluciones escalables nativas de la nube'
    },
    
    // Countdown
    countdown: {
      title: 'Cuenta Regresiva',
      days: 'Días',
      hours: 'Horas',
      minutes: 'Minutos',
      seconds: 'Segundos',
      message: 'Hasta que comience la revolución...'
    },
    
    // Form
    form: {
      title: 'Unite a la Revolución',
      subtitle: 'Sé el primero en saber cuando estemos en línea',
      name: 'Nombre Completo',
      namePlaceholder: 'Ingresá tu nombre completo',
      email: 'Dirección de Email',
      emailPlaceholder: 'Ingresá tu dirección de email',
      company: 'Empresa (Opcional)',
      companyPlaceholder: 'Ingresá el nombre de tu empresa',
      interest: 'Interés Principal',
      interestPlaceholder: 'Seleccioná tu interés principal',
      interests: {
        ai: 'Inteligencia Artificial',
        automation: 'Automatización de Procesos',
        cloud: 'Soluciones en la Nube',
        security: 'Ciberseguridad',
        analytics: 'Análisis de Datos',
        consulting: 'Consultoría en Tecnología'
      },
      message: 'Mensaje (Opcional)',
      messagePlaceholder: 'Contanos sobre tu proyecto o requerimientos...',
      submit: 'Unite al Futuro',
      submitting: 'Enviando...',
      successMessage: '¡Gracias por unirte! Te notificaremos cuando hagamos el lanzamiento.',
      errorMessage: 'Algo salió mal. Intentá de nuevo.'
    }
  },
  
  // Footer
  footer: {
    description: 'We Code What You Need - Desarrollamos soluciones personalizadas que satisfacen exactamente tus necesidades tecnológicas.',
    contact: 'Contacto',
    email: 'Email:',
    phone: 'Teléfono:',
    schedule: 'Horario:',
    scheduleText: 'Lun-Jue: 08:00-18:00 | Vie: 08:00-14:00',
    specialties: 'Especialidades',
    development: 'Desarrollo Personalizado',
    consulting: 'Consultoría Técnica',
    ai: 'Desarrollo con IA',
    automation: 'Automatización Avanzada',
    copyright: 'Z3C - Soluciones Profesionales en Tecnología. Todos los derechos reservados.',
    poweredBy: 'Desarrollado con ❤️ por Z3C'
  },
  
  // Language names
  languages: {
    en: 'English',
    ptBR: 'Português (Brasil)',
    ptPT: 'Português (Portugal)',
    es: 'Español (Argentina)'
  }
}
